import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';


import { FiEdit3, FiAward, FiUsers, FiPhone } from 'react-icons/fi';



import { GrDeliver } from "react-icons/gr";

import "../../../../assets/css/customer/subscreens/home/Features.css";
const Features = () => {
  const features = [
    {
      id: 1,
      icon: <GrDeliver />,

      title: 'DELIVERY',
      description: 'Shipping on all orders . Get your handmade products delivered to your doorstep.'
    },
    {
      id: 2,
      icon: <FiEdit3 />,
      title: 'CUSTOM ORDERS',
      description: 'Get your products personalized exactly the way you want them made.'

    },
    {
      id: 3,
      icon: <FiPhone />,
      title: '24/7 CUSTOMER SUPPORT',
      description: 'We are here to help you anytime with your queries and concerns.'
    },
    {
      id: 4,
      icon: <FiUsers />,
      title: 'MADE BY ARTISANS',
      description: 'Every product is handcrafted by skilled artisans, ensuring a unique piece just for you.'

    }
  ];

  return (
    <section className="features-section">
      <Container>
        {/* Section Heading */}
        <div className="features-header">
          <h2 className="features-main-title">WHAT MAKES US DIFFERENT</h2>
        </div>

        {/* Features Row */}
        <Row className="features-row">
          {features.map((feature) => (
            <Col 
              key={feature.id} 
              xs={12} 
              sm={6} 
              md={6} 
              lg={3} 
              className="feature-col"
            >
              <div className="feature-item">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;